export enum MappingEntityType {
    Job,
    Worker,
    Facility,
    Profession,
    Expertise,
    Unit,
    Shift
}
